import React from 'react';
import WelcomeSection from '../Landingpage/WelcomeSection';

// import Footer from '../Landingpage/Footer';
import '../Landingpage/DashboardLayout.css';
import Navbar from '../../Company/About/Navbar';
import CodeEditor from './Code';
import Footer from '../../Company/About/Footer';

export default function PPractice() {
  return (
    <div className="min-h-screen w-full bg-background flex flex-col">
      <Navbar />
      {/* <WelcomeSection /> */}
      <CodeEditor />
      <Footer />
    </div>
  );
}